import React from 'react'
import { Pane } from 'evergreen-ui'
import { FaCheck } from 'react-icons/fa'
const StatusRegister_1 = () => {
  return (
    <Pane
      color="#fff"
      backgroundColor="#008616ff"
      height="100%"
      paddingY={4}
      paddingX={5}
      fontSize={14}
      fontFamily=""
      margin={0}
      fontWeight={700}
      justifyContent="center"
      alignItems="center"
      display="flex"
      flexDirection="column"
    >
      ชำระค่าสมัครแล้ว
      รอประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์
    </Pane>

  )
}

export default StatusRegister_1